import { AppState } from '@appStates';
import { ECurrentOrderBlock } from '@enums';
import { createSelector } from '@ngrx/store';
import { ActiveMobileBlock } from 'src/app/pages/pharmacies/pharmacies.component';
import { PrivatePageState } from '../state/private.page.state';

const privatePageState = (state: AppState) => state.privatePage;

export const privatePageStateCurrentBlock = createSelector(
    privatePageState,
    (pp: PrivatePageState): ECurrentOrderBlock => pp.currentBlok
);

export const selectorExceptionPrivatePageReturnBtn = createSelector(
    privatePageState,
    (pp: PrivatePageState): string => pp.exception
);

export const selectPharmaciesPageState = createSelector(
    privatePageState,
    (pp: PrivatePageState): ActiveMobileBlock => pp.pharmaciesState
);

export const privateIsFromHomePage = createSelector(
    privatePageState,
    (pp: PrivatePageState): boolean => pp.isRoutFromHomePage
);
